import type { ExistingSiteStoreReadyBoxId } from './existingSiteStoreReadyUiStore';

export interface ExistingSiteStoreReadyTask {
  id: ExistingSiteStoreReadyBoxId;
  number: number;
  title: string;
  description: string;
}

export interface ExistingSiteStoreReadyTaskDef {
  id: ExistingSiteStoreReadyBoxId;
  number: number;
}

/** Task order and ids; copy comes from `locales/en.existing-site-store-ready.json` via `useTranslation`. */
export const EXISTING_SITE_STORE_READY_TASK_DEFS: readonly ExistingSiteStoreReadyTaskDef[] = [
  { id: 'page-ready', number: 1 },
  { id: 'margin', number: 2 },
  { id: 'delivery', number: 3 },
  { id: 'add-more-products', number: 4 },
];

export function getExistingSiteStoreReadyTaskTitleKey(id: ExistingSiteStoreReadyBoxId): string {
  return `existing-site-store-ready.tasks.${id}.title`;
}

export function getExistingSiteStoreReadyTaskDescriptionKey(id: ExistingSiteStoreReadyBoxId): string {
  return `existing-site-store-ready.tasks.${id}.description`;
}
